import { useState, useMemo } from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

interface PersonIdsTableProps {
    personIds: number[];
}

function PersonIdsTable({ personIds }: PersonIdsTableProps) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const paginated = useMemo(
        () => personIds.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [personIds, page, rowsPerPage]
    );

    return (
        <Box>
            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #dee2e6', borderRadius: 2 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                            <TableCell sx={{ fontWeight: 700, color: '#495057', width: 60 }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#495057' }}>ID Person</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginated.length > 0 ? paginated.map((personId, idx) => (
                            <TableRow key={personId} hover sx={{ bgcolor: idx % 2 === 0 ? '#fff' : '#f8f9fa' }}>
                                <TableCell sx={{ color: '#6c757d', fontWeight: 500 }}>
                                    {page * rowsPerPage + idx + 1}
                                </TableCell>
                                <TableCell sx={{ fontFamily: 'monospace', fontWeight: 600, color: '#1976d2' }}>
                                    {personId}
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={2} align="center">
                                    <Typography variant="body2" color="text.secondary">Aucun résultat</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {personIds.length > rowsPerPage && (
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={personIds.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(_, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                    labelRowsPerPage="Par page"
                />
            )}
        </Box>
    );
}

export default PersonIdsTable;
